import type {Schemas} from 'domainTypes/dto';
import {ebsApi} from 'store/ebsApi';
import type {GetUpdateLogParams, UpdateLogPage} from './types';
import {mapUpdateLogsDto} from './mappers';

export const updateLogApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getUpdateLog: build.query<
      UpdateLogPage,
      GetUpdateLogParams,
      Schemas.UpdateLogsDto
    >({
      query: ({from, to, page, size}) => ({
        url: 'updatelog',
        params: {
          from,
          to,
          page,
          size,
          sort: 'created,desc',
        },
      }),
      transformResponse: mapUpdateLogsDto,
    }),
    getUpdateLogEans: build.query<
      string[],
      Omit<GetUpdateLogParams, 'page'>,
      Schemas.UpdateLogsDto
    >({
      query: ({from, to, size}) => ({
        url: 'updatelog',
        params: {
          from,
          to,
          page: 0,
          size,
          sort: 'created,desc',
        },
      }),
      transformResponse: result => result.items?.map(item => item.ean) ?? [],
    }),
  }),
});

export const {useGetUpdateLogQuery, useLazyGetUpdateLogEansQuery} =
  updateLogApi;
